import React, { useState } from "react";
import {
  Accordion,
  AccordionLink,
  AccordionLinks,
  MobileDrawerSection,
  MobileDrawerTitle,
} from "../styled/Header.styled";
import {
  HeaderTitleArray,
  MENU_BY_TITLE,
  getHeaderLink,
  hasHeading,
} from "./data";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchBox from "./SearchBox";

const MobileDrawer = ({ isOpen, handleChangeShow }) => {
  /* keyed by nav title so adding/removing items cannot shift the mapping */
  const [activeTitle, setActiveTitle] = useState();
  const handleActive = (val) => {
    setActiveTitle(activeTitle === val ? null : val);
  };

  return (
    <>
      <MobileDrawerSection className={isOpen ? "open" : "close"}>
        <CloseIcon
          color="primary"
          style={{ position:'fixed', right:'20px'}}
          onClick={handleChangeShow}
        />
        {HeaderTitleArray.map((item, idx) => (
          <React.Fragment key={idx}>
            <MobileDrawerTitle
              onClick={() => MENU_BY_TITLE[item.title] && handleActive(item.title)}
            >
              <p>{item.title}</p>
              {MENU_BY_TITLE[item.title] &&
                (activeTitle === item.title ? (
                  <KeyboardArrowUpIcon color="primary" />
                ) : (
                  <KeyboardArrowDownIcon color="primary" />
                ))}
            </MobileDrawerTitle>
            <Accordion
              className={
                activeTitle === item.title ? "accordion-open" : "accordion-close"
              }
            >
              {MENU_BY_TITLE[item.title] &&
                Object.entries(MENU_BY_TITLE[item.title]).map(
                  ([category, items]) => (
                    <AccordionLinks key={category}>
                      {hasHeading(category) ? (
                        <a href={getHeaderLink(category)} className="link-title">
                          {category}
                        </a>
                      ) : (
                        /* headingless column - parent hides these links on mobile */
                        <span className="link-title-spacer" aria-hidden="true" />
                      )}
                      {items.map((item, index) => (
                        <AccordionLink key={index}>
                          <a href={item.link}>{item.title}</a>
                        </AccordionLink>
                      ))}
                    </AccordionLinks>
                  )
                )}
            </Accordion>
          </React.Fragment>
        ))}
        {/* parent renders its search control inside the mobile drawer too */}
        <SearchBox wide />
      </MobileDrawerSection>
    </>
  );
};

export default MobileDrawer;
